import { Student } from '../../store/viewmodels/StudentViewModel';
import { renderToString } from 'react-dom/server';
import { Task } from '../../store/viewmodels/TaskViewModel';
import { } from '../utils/DateServices';
import PrintResults from './results/resultItems/PrintResults';
import TaskResultSummary from './results/resultItems/TaskResultSummary';

export interface StudentsResultsOverviewProps {
    student?: Student,
    close: () => void
}

function StudentResultsOverView(props: StudentsResultsOverviewProps): JSX.Element {
    if (!props.student) return <></>;
    const answerSets = props.student?.results;
    const tasks: Task[] = props.student !== undefined ? props.student.task_access_list : [] as Task[];
    let taskElements = [];

    for (let i: number = 0; i < tasks.length; i++) {
        taskElements.push(<TaskResultSummary key={"taskResultSummary" + tasks[i].id} currentTask={tasks[i]} answerSets={answerSets} student={props.student} runningNumber={i} />)
    }

    function summary() {
        let studentOverview = window.open('about:blank', 'test', "width=0,height=0");
        let htmlContent = <PrintResults student={props.student} />;
        let html: string = renderToString(htmlContent);
        if (studentOverview) {
            studentOverview.document.write('<html><head><link rel="stylesheet" href="/print-styles.css" /></head><body>');
            studentOverview.document.write(html);
            studentOverview.document.write('</body></html>');
            studentOverview.document.close();
            studentOverview.focus();
        }
    }

    const buttonRow = (
        <div className="grid grid-cols-2 gap-2">
            <div className="hidden col-span-1">
                <button type="button" onClick={summary} className={"block w-full border-transparent text-sm font-medium rounded-md text-white bg-teal-500 hover:bg-teal-400 focus:shadow-outline font-bold py-2 px-4 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"}>Tulosta</button>
            </div>
            <div className="col-span-1 col-start-2">
                <button type="button" onClick={props.close} className={"block w-full border-transparent text-sm font-medium rounded-md text-white bg-gray-500 hover:bg-gray-400 focus:shadow-outline font-bold py-2 px-4 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"}>Sulje</button>
            </div>
        </div>
    );

    return (
        <div className="py-3 h-full w-full overflow-auto">
            <div className="py-3 flex border-b border-gray-200">
                <div className="flex flex-grow  pt-2 pb-2">
                    <div className="">
                        <h1 className="ml-4 text-2xl font-extrabold text-gray-900">{props.student?.identification}</h1>
                        <h1 className="ml-4 text-2xl text-gray-500">{props.student?.username}</h1>
                    </div>
                </div>
                <div className="w-1/2 mr-2">
                    {buttonRow}
                </div>
            </div>
            {taskElements}
            <div className="py-3 float-right w-1/2 mr-2">
                {buttonRow}
            </div>
        </div>
    );
}




export default StudentResultsOverView;